module.exports = __webpack_public_path__ + "static/img/first.20399851.png";